import forms from '@/libs/forms';

import VueFormGenerator from 'vue-form-generator';

export default {
  insurance: {
    schema: {
      fields: [
        forms.currency(
          'Total Annual Policy Premium amount?',
          'annual_policy_premium_amount',
          true,
          '6',
        ),
        {
          type: 'textArea',
          label: 'Policy Number:',
          model: 'policy_number',
          required: true,
          styleClasses: 'col-md-6',
          hint: 'Max 128 characters',
          max: 128,
          rows: 1,
          validator: VueFormGenerator.validators.string,
        },
        {
          type: 'textArea',
          label: 'Type of insurance:',
          model: 'insurance_type',
          required: true,
          styleClasses: 'col-md-12',
          hint: 'Max 128 characters',
          max: 128,
          rows: 1,
          validator: VueFormGenerator.validators.string,
        },
        forms.currency(
          'Total Deductible amount?',
          'deductible_amount',
          true,
          '6',
        ),
        forms.currency(
          'Total Coverage amount?',
          'coverage_amount',
          true,
          '6',
        ),
        forms.date('Effective Date', null, 'effective', true, 6),
        forms.date('Expiration Date', null, 'expiration', true, 6),
        {
          type: 'radios',
          label: 'Is the annual policy premium for this policy paid for?',
          model: 'annual_policy_premium_paid_for',
          required: true,
          styleClasses: 'col-md-12 flex-radio',
          values: [
            { name: 'Yes', value: true },
            { name: 'No', value: false },
          ],
          validator: VueFormGenerator.validators.required,
        },
        {
          type: 'textArea',
          label: 'Explanation of coverage:',
          model: 'coverage_description',
          required: true,
          styleClasses: 'col-md-12',
          hint: 'Max 500 characters',
          max: 500,
          rows: 4,
          validator: VueFormGenerator.validators.string,
        },
      ],
    },
    options: forms.options('insurance-', true),
  },
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/insurance/resources/schema.js